import { BASE_H, BASE_W, TILE_SIZE } from '@/config/constants';
import type { MotionType } from '@/types/models';
import type { TileSprite } from '@/game/objects/TileSprite';

const randRange = (min: number, max: number) => min + Math.random() * (max - min);

export interface MotionAssignment {
  x: number;
  y: number;
  vx: number;
  vy: number;
  gravity: number;
  /** Si está presente, se usa en lugar de `gravity` cuando vy >= 0 (caída). */
  gravityDown?: number;
  /** Velocidad máxima de caída en px/s. */
  terminalVy?: number;
}

export function spawnPositionFor(motion: MotionType, level: number): MotionAssignment {
  const variant = motion === 'mixed' ? (Math.random() < 0.5 ? 'fall' : 'parabolic') : motion;

  if (variant === 'fall') {
    const padding = TILE_SIZE / 2 + 40;
    const x = randRange(padding, BASE_W - padding);
    const y = -TILE_SIZE / 2;
    const fallSpeed = 220 + level * 18 + randRange(-30, 60);
    return { x, y, vx: 0, vy: fallSpeed, gravity: 0 };
  }

  // Parabolic (lanzamiento vertical): el cuadro sube en línea recta desde abajo,
  // alcanza un pico cerca del techo y cae en cámara lenta sin desviación horizontal.
  // - Subida: vy y gravedad reducidos (1/√2 y 1/2) → mismo pico, subida tranquila.
  // - Bajada: gravityDown muy pequeña + terminalVy estilo Tetris (cap de velocidad).
  const padding = TILE_SIZE / 2 + 40;
  const x = randRange(padding, BASE_W - padding);
  const y = BASE_H + TILE_SIZE / 2;

  const vx = 0;
  const vy = -(2150 + level * 30 + randRange(-100, 200)) * 0.71;
  const gravity = (1300 + level * 10) * 0.5;
  const gravityDown = gravity * 0.25;
  const terminalVy = 200 + level * 10;
  return { x, y, vx, vy, gravity, gravityDown, terminalVy };
}

export function isOffscreen(tile: TileSprite): boolean {
  const margin = TILE_SIZE * 1.4;
  return (
    tile.y > BASE_H + margin ||
    tile.y < -margin * 3 ||
    tile.x < -margin ||
    tile.x > BASE_W + margin
  );
}
